import { useShow, IResourceComponentsProps, useGetIdentity } from '@pankod/refine-core'
import { IWorkRequest } from 'interfaces'
import { WorkRequestPageHeader } from './showPageHeader'

import { useEffect, useState } from 'react'
import metaData from 'metadata/workrequests'
import { useInvalidate } from '@pankod/refine-core'
import { CompletionStatus, getWorkRequestStatusCount } from 'helpers'
import { useUserContext } from 'context/user'
import { CheckUserAccess } from 'components/accessability'
import { ErrorComponent } from '@pankod/refine-antd'

export const WorkRequestShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<IWorkRequest>({
    metaData,
  })
  const [errorCode, setErrorCode] = useState<any>(200)
  const { userRole } = useUserContext()
  const invalidate = useInvalidate()
  const { data, isLoading, refetch } = queryResult
  const { data: user } = useGetIdentity()
  const record = data?.data

  const updatePercentage = (id: string) => {
    queryResult.refetch()
    invalidate({
      resource: 'work_requests',
      invalidates: ['detail'],
      id: record?.id,
    })
    invalidate({
      resource: 'questions',
      invalidates: ['list'],
      
     
    })
    // getWorkRequestStatusCount(record)
  }
  useEffect(() => {
    let code: any = 200
    code = CheckUserAccess('work_request', 'show', user?.id, record, userRole)
    setErrorCode(code)
  }, [user, record, userRole])
  return (
    <>
      {errorCode === 200 ? (
        <>
          <WorkRequestPageHeader record={record} metaData={metaData} updatePercentage={updatePercentage} />
        </>
      ) : (
        <ErrorComponent />
      )}
    </>
  )
}
